// Row actions, copied from Component/Analytics/Components/MessageDetails.js and
// ViewMessage.js so the current Analytics page stays unchanged.
// `message` is the full message from getMsgBy_Id(_id, true), which includes
// versionB for A/B messages.
import moment from 'moment';
import {
  saveNewDraftService,
  mergeABdraftsService,
  updateMsg,
  cancelEmails,
  cancelTexts,
} from '../../redux/services';

export const viewMessage = message => {
  window.open(
    `${process.env.REACT_APP_webUrl}/message?id=${message.id}`,
    '_blank'
  );

  if (message.versionB) {
    window.open(
      `${process.env.REACT_APP_webUrl}/message?id=${message.versionB.id}`,
      '_blank'
    );
  }
};

const convertMessageToDraft = (message, { userId, organizationId }) => ({
  name: message.draftName,
  subject: message.messageSubject,
  sender: message.from,
  senderName: message.sender,
  replyTo: message.replyTo,
  preheader: message.preheader,
  html: message.messageBody,
  design: message.messageDesign,
  saveTime: moment().unix(),
  userId,
  organizationId,
  topicIds: message.topicIds || [],
  selectedGroupIds: message.selectedGroupIds || [],
  requiredGroupIds: message.requiredGroupIds || [],
  excludedGroupIds: message.excludedGroupIds || [],
  includedMemberIds: message.includedMemberIds || [],
  excludedMemberIds: message.excludedMemberIds || [],
  filterData: { ...(message.filterData || {}) },
  status: 'Active',
});

// Creates a draft from the message (A and B merged for an A/B message) and
// returns the new draft's _id.
export const duplicateToDraft = async (message, ids) => {
  const draft = await saveNewDraftService(convertMessageToDraft(message, ids));
  if (message.versionB) {
    const draftBdata = convertMessageToDraft(
      { ...message.versionB, draftName: draft.name },
      ids
    );
    await mergeABdraftsService(draft._id, draftBdata);
  }
  return draft._id;
};

export const handleDownload = (blob, fileName) => {
  const href = URL.createObjectURL(blob);

  // create "a" HTLM element with href to file
  const link = document.createElement('a');
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL (helps prevent memory leaks)
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

const downloadMessageFile = (messageData, fileName) => {
  const messageJson = JSON.stringify(messageData.messageDesign, null, 2);
  const jsonBlob = new Blob([messageJson], { type: 'application/json' });
  handleDownload(jsonBlob, fileName + '.json');

  const htmlBlob = new Blob([messageData.messageBody], {
    type: 'text/plain',
  });
  handleDownload(htmlBlob, fileName + ' (html)' + '.txt');
};

export const exportMessageDesign = message => {
  downloadMessageFile(message, message.messageSubject);

  //If there is a B version, also download the B version
  if (message.versionB?._id) {
    downloadMessageFile(message.versionB, message.versionB.messageSubject);
  }
};

// Same calls as ViewMessage.handleCancel. Rows are always version A.
export const emergencyCancel = async messageId => {
  await updateMsg({ msgId: messageId, cancelled: true });
  await cancelEmails(messageId);
  await cancelTexts(messageId);
};
